import React, { useContext, useEffect } from 'react';

import WebpWithFallback from '@swf/components/WebpWithFallback/WebpWithFallback';

import Buttons from './Buttons';
import DotProgressIndicator from './DotProgressIndicator';
import styles from './NewUser.scss';
import NewUserContext from './NewUserContext';

interface Props {
  activePage: number;
  webPImage: string;
  pngImage: string;
  mainText: JSX.Element;
  additionalText: JSX.Element;
}

function Content({ pngImage, webPImage, additionalText, mainText, activePage }: Props) {
  const { setState } = useContext(NewUserContext);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setState((previousState) => ({ ...previousState, activePage })), [setState]);

  return (
    <div className={styles.content}>
      <WebpWithFallback
        imageSize={{ height: 214, width: 377 }}
        containerClassName={styles.image}
        src={webPImage}
        srcFallback={pngImage}
      />
      <div className={styles.textContainer}>
        {mainText}
        {additionalText}
      </div>
      <DotProgressIndicator />
      <Buttons />
    </div>
  );
}

export default Content;
